<template>
	<DjCard
		v-if="!loading"
		class="relative flex justify-between w-full max-w-[320px] border-0 bg-transparent pb-4 cursor-pointer"
		hover
		@click="$emit('onCardClick')"
	>
		<!-- Stretched link: covers the entire card for SSR-crawlable navigation -->
		<a
			v-if="postHref"
			:href="postHref"
			:target="newTab ? '_blank' : undefined"
			class="absolute inset-0 z-0"
			:aria-label="title ? title : 'Blog post details'"
			tabindex="-1"
		></a>
		<!-- <img class="relative min-h-[220px] w-full rounded-2xl mb-5" :src="photoUrl" /> -->
		<BaseCloudImage
			class="mb-5 bg-dj-gray h-[220px]"
			alt="post-cover-image"
			custom-class="rounded-2xl overflow-hidden"
			image-class="h-[220px] object-cover"
			:public-id="publicId"
			:transformation="[{ height: 220, crop: 'scale' }]"
		/>
		<div class="flex flex-col px-4">
			<div class="flex justify-start">
				<BaseLink @click.stop="$emit('onCategoryClick')" class="relative z-10 text-sm mb-3" type="grey">
					{{ category }}
				</BaseLink>
			</div>
			<DjClampedTitle :title="title" class="h-dj-70 my-auto flex items-center text-left" :clamp="3" />
			<div class="flex flex-row items-center mt-2 w-full">
				<span v-if="time" class="flex items-center text-dj-grey text-sm">
					<span class="material-icons-outlined text-base mr-1">access_time</span>
					{{ time }}
				</span>

				<BaseLink
					class="relative z-10 ml-auto"
					:href="postHref || undefined"
					:target="newTab ? '_blank' : undefined"
				>
					<span class="text-sm font-medium capitalize">{{ cta }}</span>
					<span class="material-icons-outlined pl-2 text-base">arrow_forward</span>
				</BaseLink>
			</div>
		</div>
	</DjCard>
	<!-- Loading state -->
	<DjCard v-else class="bg-white border-dj-light-blue animate-pulse">
		<div class="relative w-full min-h-[220px] rounded-2xl mb-5 bg-dj-gray-minimal"></div>

		<div class="flex flex-col px-4 pb-4">
			<div class="w-3/4 h-4 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>

			<div class="w-full h-5 mt-2 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
			<div class="w-full h-5 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
			<div class="w-full h-5 mb-2 my-auto flex rounded-lg bg-dj-gray-minimal"></div>

			<div class="flex flex-row justify-between mt-2">
				<div class="w-16 h-4 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>

				<div class="w-24 h-4 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
			</div>
		</div>
	</DjCard>
</template>

<script lang="ts">
import DjCard from "./DjCard.vue";
import BaseLink from "../BaseLink.vue";
import DjClampedTitle from "./partials/DjClampedTitle.vue";

import { defineComponent } from "vue";

export default defineComponent({
	name: "DjCardBlog",
	components: {
		DjCard,
		DjClampedTitle,
		BaseLink,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		category: {
			type: String,
			default: "",
			required: true,
		},
		time: {
			type: String,
			default: "",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		publicId: {
			type: String,
			default: "",
		},
		locale: {
			type: String,
			default: "hu",
		},
		cta: {
			type: String,
			default: "",
			required: true,
		},
		postHref: {
			type: String,
			default: "",
		},
		newTab: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["onCardClick", "onCategoryClick"],
});
</script>
